import * as Tabs from '@radix-ui/react-tabs'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { PageHeader } from '@/components/ui/PageHeader'
import { SlidingTabsList, slidingTabTrigger } from '@/components/ui/SlidingTabsList'
import { useAuth } from '@/lib/auth'
import { AdminTab } from './admin'
import { AuditTab } from './audit'
import { ConnectionsTab } from './connections'
import { PersonalTab } from './personal'
import { SystemTab } from './system'

export function SettingsPage() {
  const auth = useAuth()
  const role = auth.data?.user.role
  const admin = role === 'ADMIN'
  const search = useSearch({ strict: false }) as { tab?: string }
  const navigate = useNavigate()
  const visibleTabs = admin
    ? ['tokens', 'personal', 'admin', 'system', 'audit']
    : ['tokens', 'personal']
  const tab = search.tab && visibleTabs.includes(search.tab) ? search.tab : 'tokens'
  function setTab(next: string) {
    navigate({
      to: '/instellingen',
      search: (prev) => ({ ...prev, tab: next === 'tokens' ? undefined : next }),
      replace: true,
    })
  }

  return (
    <div className="space-y-6">
      <PageHeader title="Instellingen" description="Koppelingen, je eigen voorkeuren en, voor beheerders, personen en huisstijlen." />
      <Tabs.Root value={tab} onValueChange={setTab}>
        <SlidingTabsList value={tab}>
          <Tabs.Trigger value="tokens" className={slidingTabTrigger}>Koppelingen</Tabs.Trigger>
          <Tabs.Trigger value="personal" className={slidingTabTrigger}>Persoonlijk</Tabs.Trigger>
          {admin ? <Tabs.Trigger value="admin" className={slidingTabTrigger}>Beheer</Tabs.Trigger> : null}
          {admin ? <Tabs.Trigger value="system" className={slidingTabTrigger}>Systeem</Tabs.Trigger> : null}
          {admin ? <Tabs.Trigger value="audit" className={slidingTabTrigger}>Audit</Tabs.Trigger> : null}
        </SlidingTabsList>
        <Tabs.Content value="tokens" className="mt-4"><ConnectionsTab /></Tabs.Content>
        <Tabs.Content value="personal" className="mt-4"><PersonalTab /></Tabs.Content>
        {admin ? <Tabs.Content value="admin" className="mt-4"><AdminTab /></Tabs.Content> : null}
        {admin ? <Tabs.Content value="system" className="mt-4"><SystemTab /></Tabs.Content> : null}
        {admin ? <Tabs.Content value="audit" className="mt-4"><AuditTab active={tab === 'audit'} /></Tabs.Content> : null}
      </Tabs.Root>
    </div>
  )
}
